import { render, staticRenderFns } from "./DepartureStatisticsCard.vue?vue&type=template&id=3773a03e&scoped=true"
import script from "./DepartureStatisticsCard.vue?vue&type=script&lang=js"
export * from "./DepartureStatisticsCard.vue?vue&type=script&lang=js"
import style0 from "./DepartureStatisticsCard.vue?vue&type=style&index=0&id=3773a03e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3773a03e",
  null
  
)

export default component.exports